const EN = {
    "loginTitle": "Log In",
    "mobileNumLabel": "Mobile No",
    "passwordLabel": "Password",
    "loginButton": "Login",
    "forgotPasswordLink": "Forgot Password?",
    "forgotPassword": "Forgot Password",
    "forgotPasswordButton": "Reset password",
    "signupPrompt": "Not a member yet?",
    "navHome": "Home",
    "navLocation": "Location",
    "navProfile": "Profile",
    "navInstaller": "Installer",
    "navAbout": "About",
    "verificationCodeLabel": "Verification Code (SMS)",
    "nameLabel": "Name or Company Name",
    "icNumLabel": "IC Number",
    "emailLabel": "Email Address",
    "retypePasswordLabel": "Retype Password",
    "termsText": "*I agree with the <a href='#'>terms and conditions</a>",
    "signupButton": "Sign Up",
    "mobileNumPlaceholder": "Enter mobile no",
    "verificationCodePlaceholder": "Enter verification code",
    "namePlaceholder": "Enter name or company name",
    "icNumPlaceholder": "Enter IC no",
    "emailPlaceholder": "Enter email address",
    "otpButton": "Request OTP",
    "faq1": "1. How to enlist my company as Installer?",
    "faq11": "Press 'Installer' at the bottom right corner and select 'Apply'. After you applied as installer, please inform us to get yourself listed in the installer's category. ",
    "faq2": "2. What is the Installer for?",
    "faq22": "The installer section is to help our users find the right installer to fulfill on lighting fixtures and fittings.",
    "faq3": "3. How to Rate Installer?",
    "faq33": "Go to 'Installer' (bottom tab bar) and select on the installer you requested before, select 'Rate & Review' to comment and rate. This option can only be used after making purchase from AK Lighting.",
    "faq4": "4. Can I use my own installer?",
    "faq44": "Yes, you can. Please note that any installer that are not registered in our apps will not be able for rate and review within our apps platform.",
    "faq5": "5. What is Inbox?",
    "faq55": "When there is a promotion, you will automatically be notified. The message received will be send to Inbox. Turn on app notification so you will not miss the promotion period.",
    "faq6": "6. Where can I find my receipt?",
    "faq66": "Go to 'Profile', top right 'Purchase History' to check your purchase.",
    "faq7": "7. Where can I check my total points?",
    "faq77": "Go to 'Profile', you will see your points along with your Name, IC No. and Mobile No. You can also edit your own profile picture by tapping on 'Edit Photo'.",
    "faq8": "8. What are points?",
    "faq88": "A total of 500 points will be credited to you immediately when your register as AK Lighting member. When you purchase items from AK",
    "notificationText": "Notification",
    "helplineText": "Helpline",
    "productsText": "Products",
    "aboutusText": "About Us",
    "faqText": "FAQ",
    "languageText": "Language",
    "facebookText": "Facebook",
    "logoutText": "Logout",
    "about1": "A.K Lighting is a subsidiary company founded by JUSTlight. As we all know, JUSTlight showroom premises is not convenient to do stock clearance promotion due to limited parking lot.",
    "about2": "Therefore, we start up a new company A.K. Lighting, here at Canaan Square there are plenty of parking lots and are free of charge. You even can have direct access to our showroom. We believe its whole lot more convenient for our valued customers.",
    "about3": "Our stocks clearance are all valuable goods. Due to led pricing is depreciating nowadays, and we still have a lot of old stocks, we are doing clearance for those old stocks so we can bring in more new products. Here you can find cheap and affordable lighting.",
    "about4": "We are also purchasing branded items like Philips in a high volume so we can do bulk sales for consumer's benefit. Here you can find all sorts of lighting for your apartment, low cost housing, air bnb, and etc. Besides that, we also bring in all sorts of accessories for the convenience to modify lighting and accessories for contractors usage. We will bring in more accessories in future for your convenience. ",
    "about5": "For our own app, we allow users to get the latest updates on our promotion. We also provide contacts of contractors where you can appoint to do installation of lightings. A.K. Lighting bringing lighting solutions to life.",
    "installerTitle": "Installer",
    "applyButton": "Apply",
    "detailsButton": "Details Info",
    "reviewButton": "Rate & Review",
    "mapLink": "See Map,",
    "addressText": "Address:",
    "openHours": "Open Hours:",
    "dateText": "Monday to Sunday 8:30am - 5:30pm",
    "contactText": "Contact:",
    "installerApply": "Installer Apply",
    "applyTitle": "Installer Form",
    "companyLabel": "Company Name",
    "contactLabel": "Contact",
    "contactPlaceholder": "Enter contact",
    "genderLabel": "Gender",
    "genderChoice": "Select gender",
    "maleOption": "Male",
    "femaleOption": "Female",
    "raceLabel": "Race",
    "racePlaceholder": "Enter race",
    "experienceLabel": "Year of Experience",
    "experiencePlaceholder": "Enter year of experience",
    "workerLabel": "No. of worker",
    "workerPlaceholder": "Enter no. of worker",
    "specialtyLabel": "Specialty",
    "specialty1": "Lighting",
    "specialty2": "Wiring",
    "specialty3": "Fan",
    "specialty4": "Project",
    "otherLabel": "Other",
    "otherPlaceholder": "Enter other specialty",
    "addressLabel": "Address",
    "addressPlaceholder": "Enter Address",
    "submitButton": "Submit",
    "invoiceLabel": "Invoice no to rate & comment",
    "invoiceSelect": "Select Invoice no.",
    "ratingLabel": "Rating",
    "commentLabel": "Comments",
    "commentPlaceholder": "Enter Comments",
    "uploadLabel": "Upload Photo",
    "closeButton": "Close",
    "profileTitle": "Profile",
    "mobileUpdate": "Mobile Update",
    "passwordUpdate": "Password Update",
    "referralList": "Referral List",
    "deleteAccount": "Close Account",
    "deleteText": "Permanently delete your account",
    "deleteTitle": "Confirm close account?",
    "postDeletion": "We will contact on mobile number and ask for some details to deletion of account. Once everything is confirm, account will be queue for deletion within 30 days.",
    "cancelDelete": "Cancel",
    "confirmDelete": "Confirm",
    "purchaseHistory": "Purchase History",
    "editButton": "Edit",
    "editPhoto": "Edit Photo",
    "memberName": "Name:",
    "memberIc": "Ic No:",
    "memberMobile": "Mobile No:",
    "pointLabel": "Total Point",
    "memberLabel": "Member Since",
    "Are you sure you wnat to logout?": "Are you sure you wnat to logout?",
    "About Menu": "About Menu",
    "OTP must be 6 digits": "OTP must be 6 digits",
    "Password and Confirm Password not match": "Password and Confirm Password not match",
    "Invalid Login Credential": "Invalid Login Credential",
    "no_internet": "Server connection problem",
    "Login successfully!": "Login successfully!",
    "Please Check terms and condition": "Please Check terms and condition",
    "OTP not Valid": "OTP not Valid",
    "termsText1": "*I agree with the ",
    "termsText2": "terms and conditions",
    "Promotion": "Promotion",
    "Category": "Category",
    "Ratings": "Ratings",
    "ContactNoTitle": "Contact No.",
    "Overall Rating": "Overall Rating",
    "(no rating)": "(no rating)",
    "Overall Rating (no rating)": "Overall Rating (no rating)",
    "AK Lighting (Canaan Square Stutong)": "AK Lighting (Canaan Square Stutong)",
    "addressText1": "No. C2-G-4 Block C, Lobby 2, Ground Floor, Unit 4, Canaan Square, Q403A, 93350 Kuching, Sarawak",
    "AK Lighting (Matang Metrocity)": "AK Lighting (Matang Metrocity)",
    "addressText2": "Ground Floor, S/L 22&23, Survey Lot 13768 Sect. 65, KTLD, Metrocity, Jalan Matang, Jalan Matang, 93050 Kuching, Sarawak",
    "Description:": "Description:",
    "Old Password Required": "Old Password Required",
    "Password Required": "Password Required",
    "Confirm Password Required": "Confirm Password Required",
    "New Password": "New Password",
    "Confirm Password": "Confirm Password",
    "Copy Incoive ID": "Copy Incoive ID",
    "Invoice No:": "Invoice No:",
    "Subtotal:": "Subtotal:",
    "Discount:": "Discount:",
    "Tax:": "Tax:",
    "View": "View",
    "Invoice": "Invoice",
    "Id": "Id",
    "Name": "Name",
    "Price": "Price",
    "QTY": "QTY",
    "Total": "Total",
    "Grand Total:": "Grand Total:",
    "oldPasswordLabel": "Old Password",
    "City": "City",
    "SelectCity": "Select City",
    "otherOption": "Other",
    "Announcement": "Announcement",
    "Load More": "Load More",
    "No more data to load": "No more data to load",
    "Data not found!": "Data not found!",
    "PointsHistory": "Points History",
    "Next_link_not_found": "Next link not found!",
};
export default EN;